import { ProsePage } from "./Privacy";

export default function LegalNotice() {
  return <ProsePage endpoint="/public/legal" title="Mentions légales" subtitle="Informations légales — loi n° 2004-575 du 21 juin 2004 (LCEN)" prefix="legal" />;
}
